<template>
	<div class="container">
		<div class="flex-between headwarp">
			<div class="head-item" @click="goChooseClassfiy()">1.选择类别</div>
			<div class="head-item active">2.填写信息</div>
			<div class="head-item">3.完成发布</div>
		</div>
		<div class="cont-body">
			<div class="content hundvh">
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">标签<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b">
						<el-radio-group v-model="travelIndex" class="radio_warp">
							<div v-for="(item,index) in array" :key="item.key" class="radio_itm_warp">
								<el-radio :label="item.key">{{item.value}}</el-radio>
							</div>
						</el-radio-group>
					</div>
				</div>
				<template v-if="travelIndex.startsWith('nkcor')">
					<div class="ctx-item">
						<div class="ctx-item-t">
							<div class="ctx-item-head">名称<label class="bishu">*</label></div>
						</div>
						<div class="ctx-item-b" >
							<el-input placeholder="请输入名称" v-model="storeCorName" maxlength="30" />
						</div>
					</div>
					<div class="ctx-item">
						<div class="ctx-item-t">
							<div class="ctx-item-head">地址<label class="bishu">*</label></div>
						</div>
						<div class="ctx-item-b" >
							<el-input placeholder="请输入地址" v-model="storeCorAddr" maxlength="80" />
						</div>
					</div>
					<div class="ctx-item">
						<div class="ctx-item-t">
							<div class="ctx-item-head">简介<label class="bishu">*</label></div>
						</div>
						<div class="ctx-item-b">
							<el-input type="textarea" v-model="storeCorDesc" :autosize="{ minRows: 4}" maxlength="200" placeholder="请输入简介！" show-word-limit></el-input>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="ctx-item">
						<div class="ctx-item-t">
							<div class="ctx-item-head">面向地区<label class="bishu">*</label></div>
						</div>
						<div class="ctx-item-b">
							<el-cascader
							    v-model="areaId"
								:props="cascaderprops"
							    :options="citysList"
							    @change="handleCityChange">
							</el-cascader>
						</div>
					</div>
					<div class="ctx-item" v-if="travelIndex == '0'">
						<div class="ctx-item-t"><div class="ctx-item-head">航班<label class="bishu">*</label></div></div>
						<div class="ctx-item-b flex-start">
							<div><el-input v-model="fromWhere" class="mrgr10" maxlength="10" placeholder="请输入出发点" /></div>
							<div class="icon_flying"></div>
							<div><el-input v-model="toWhere" class="mrgr10" maxlength="10" placeholder="请输入目的地" /></div>
						</div>
					</div>
					<div class="ctx-item" v-if="travelIndex == '0'">
						<div class="ctx-item-t">
							<div class="ctx-item-head" v-if="travelIndex == '0'">航班日期<label class="bishu">*</label></div>
							<div class="ctx-item-head" v-else-if="travelIndex == '4'">门票日期<label class="bishu">*</label></div>
						</div>
						<div class="ctx-item-b" >
							<el-date-picker
								v-model="limitDate"
								type="date"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								placeholder="选择日期时间">
							</el-date-picker>
						</div>
					</div>
					<div class="ctx-item" v-if="travelIndex == '0'">
						<div class="ctx-item-t">
							<div class="ctx-item-head">航班号<label class="bishu">*</label></div>
						</div>
						<div class="ctx-item-b" >
							<el-input v-model="fightNumber" class="mrgr10" maxlength="30" placeholder="请输入航班号" />
						</div>
					</div>
					<template v-if="this.travelIndex == '1' || this.travelIndex == '4'">
						<div class="ctx-item">
							<div class="ctx-item-t">
								<div class="ctx-item-head">名称<label class="bishu">*</label></div>
							</div>
							<div class="ctx-item-b" >
								<el-input v-model="hotelName" class="mrgr10" maxlength="30" placeholder="请输入酒店/景点/娱乐店名称" />
							</div>
						</div>
						<div class="ctx-item inlinediv">
							<div class="ctx-item-t">
								<div class="ctx-item-head">使用日期<label class="bishu">*</label></div>
							</div>
							<div class="ctx-item-b" >
								<el-date-picker
									v-model="serviceDate"
									type="date"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									placeholder="选择日期时间">
								</el-date-picker>
							</div>
						</div>
						<div class="ctx-item inlinediv">
							<div class="ctx-item-t">
								<div class="ctx-item-head">到期日期<label class="bishu">*</label></div>
							</div>
							<div class="ctx-item-b" >
								<el-date-picker
									v-model="expiryDate"
									type="date"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									placeholder="选择日期时间">
								</el-date-picker>
							</div>
						</div>
					</template>
					<div class="ctx-item">
						<div class="ctx-item-t">
							<div class="ctx-item-head">价格(元)<label class="bishu">*</label></div>
						</div>
						<div class="ctx-item-b" >
							<el-input v-model="price" class="mrgr10" type="digit" maxlength="8" placeholder="请输入价格" />
						</div>
					</div>
					<div class="ctx-item">
						<div class="ctx-item-t">
							<div class="ctx-item-head">送货方式<label class="bishu">*</label></div>
						</div>
						<div class="ctx-item-b">
							<el-radio-group v-model="deliveryModel" class="radio_warp">
								<div v-for="(item,index) in deliveryModelList" :key="item.key" class="radio_itm_warp">
									<el-radio :label="item.key">{{item.value}}</el-radio>
								</div>
							</el-radio-group>
						</div>
					</div>
					<div class="ctx-item">
						<div class="ctx-item-t">
							<div class="ctx-item-head">详细说明<label class="bishu">*</label></div>
							<div class="ctx-item-headdesc">(稍加修饰点缀才有吸引力哦~)</div>
						</div>
						<div class="ctx-item-b">
							<el-input type="textarea" v-model="reqNail" :autosize="{ minRows: 4}" maxlength="200" placeholder="请输入内容" show-word-limit></el-input>
						</div>
					</div>
				</template>
				
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">是否置顶（30天）<label class="bishu">*</label></div>
					</div>
					<div class="ctx-item-b" style="text-align: right;">
						<el-switch
							v-model="tickTopOrNot"
							@change="tickTopChange"
							active-color="#13ce66"
							inactive-color="#ff4949">
						</el-switch>
					</div>
				</div>
				<div class="ctx-item inlinediv">
					<pickContact ref="pickContact" :queryUid="userInfo.fayanboId" :baseUrlpath="baseUrlpath" @changeConcactShow="changeConcactShow" :isShowConcact="isShowConcact" :isDetail="isDetail"></pickContact>
				</div>
				<div class="ctx-item">
					<div class="ctx-item-t">
						<div class="ctx-item-head">上传照片/视频<label class="bishu">*</label></div>
						<div class="ctx-item-headdesc"><label>({{finalFileList.length}}/{{limitFilesNum}})</label></div>
					</div>
					<div class="ctx-item-b">
						<uploadFile :baseUrlpath="baseUrlpath" :fileList="fileList" @addOrMulitiFileList="addOrMulitiFileList"></uploadFile>
					</div>
				</div>
				<div class="ctx-item">
					<div class="ctx-item-b">
						<div class="pub_jd_cost">
							<div class="jd_total">
								<label class="unit">共需花费</label>
								<label class="num">{{pubTotalCost}}</label>
								<label class="unit">金豆</label>
							</div>
							<div class="cost_desc">
								<label>发布</label>
								<label class="num">{{pubNeedCost}}</label>
								<label>金豆</label>
								<template v-if="tickTopOrNot">
									<label>+</label>
									<label>置顶</label>
									<label class="num">{{tickTopNeedCost}}</label>
									<label>金豆</label>
								</template>
							</div>
						</div>
					</div>
				</div>
				<div class="req_tips">
					<div>1.支付前请确认与发布人确认好细节</div>
					<div>2.请尽量选择已担保客户已实名认证的客户以防止后期质量问题</div>
					<div>3.本平台仅提供信息交流服务，不承担任何法律责任</div>
					<div>4.如未使用服务且不确定的情况下请勿点击确认完成</div>
					<div>5.平台支付后请勿立即确认完成，收到货或服务完成后，确认完成后平台不可退款</div>
					<div>6.线上支付交易，平台收取6%服务费</div>
				</div>	
				<div class="btn-foot">
					<div class="btn" @click="publish()">确认发布</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapGetters,mapActions} from 'vuex'
	import uploadFile from '@/components/upload/uploadFile.vue'
	import pickContact from '@/components/pickContact.vue'
	import {queryUrl,doPost,commitFileUrl,queryUrlWithUInfo,postWithUInfo} from '@/api/index';
	import { Toast } from 'mint-ui';
	export default {
		components:{
		  uploadFile,pickContact
		},
		data(){
			return {
				cascaderprops:{
					value:'id',
					label:'name',
					children:'child'
				},
				reqType:'',
				price:'',
				areaId:'',
				reqNo:'',
				reqNail:'',
				storeCorName:'',
				storeCorlatitude:'',
				storeCorlongitude:'',
				storeCorAddr:'',
				storeCorDesc:'',
				deliveryModel:'0',
				deliveryModelList:[],
				indicatorStyle: `height: 50px;`,
				maskStyle:``,
				fileList:[],
				finalFileList:[],
				citysList:[],
				limitFilesFlg:true,
				limitFilesNum:9,
				baseUrlpath:'',
				travelIndex:'0',
				array:[],
				limitDate:'',
				fromWhere:'',
				toWhere:'',
				isShowConcact:true,
				tickTopOrNot:false,
				tickTopNeedCost:0,
				pubNeedCost:0,
				pubTotalCost:0,
				isDetail:false,
				sdr_userId:'',
				serviceDate:'',
				expiryDate:'',
				hotelName:'',
				fightNumber:''
			}
		},
		created() {
			// console.log(this.$route.query)
			this.reqType = this.$route.query.reqType;
			this.citysList = this.$util.citysList;
			this.array = this.$util.travelLebels;
			this.deliveryModelList = this.$util.deliveryModelList;
			this.queryTickJdCost()
			this.queryPubJdCost()
		},
		computed: {
			...mapGetters(['userInfo'])
		},
		watch:{
			tickTopNeedCost:{
				handler(val, oldval) {
					if(this.tickTopOrNot){
						this.pubTotalCost = parseInt(val) + parseInt(this.pubNeedCost) 
					}else{
						this.pubTotalCost = parseInt(this.pubNeedCost)
					}
				}
			},
			pubNeedCost:{
				handler(val, oldval) {
					if(this.tickTopOrNot){
						this.pubTotalCost = parseInt(val) + parseInt(this.tickTopNeedCost) 
					}else{
						this.pubTotalCost = parseInt(val)
					}
				}
			},
			tickTopOrNot:{
				handler(val, oldval) {
					console.log(val)
					if(val){
						this.pubTotalCost = parseInt(this.pubNeedCost) + parseInt(this.tickTopNeedCost) 
					}else{
						this.pubTotalCost = parseInt(this.pubNeedCost)
					}
				}
			}
		},
		methods:{
			tickTopChange(e){
				var needCost = this.tickTopNeedCost;
				var _this = this;
				console.log(e)
				if(e){
					this.$confirm('置顶需花费'+needCost+'金豆'+', 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						
					}).catch(() => {
						_this.tickTopOrNot = false       
					});
				}
			},
			async queryTickJdCost(){
				const initres = await queryUrlWithUInfo('/apis/queryJdNeedCost',{queryType:'1'});
				if(initres.ec == '0'){
					this.tickTopNeedCost = parseInt( initres.jdCost)
				}
			},
			async queryPubJdCost(){
				const initres = await queryUrlWithUInfo('/apis/pubJdNeedCost',{queryType:'1'});
				if(initres.ec == '0'){
					this.pubNeedCost = parseInt(initres.jdCost)
				}
			},
			changeConcactShow(val){
				this.isShowConcact = val
			},
			goBack() {
				this.$util.goBack();
			},
			async publish(){
				var vm = this;
				if(this.travelIndex.startsWith('nk')){
					if(this.travelIndex.startsWith('nkcor')) {
						if(this.storeCorName.length == 0){
							this.$util.warnMsg('请输入名称');
							return false;
						}
						if(this.storeCorAddr.length == 0){
							this.$util.warnMsg('请输入地址');
							return false;
						}
						if(this.storeCorDesc.length == 0){
							this.$util.warnMsg('请输入简介');
							return false;
						}
					}
					if(this.finalFileList.length > 0){
						this.$util.warnMsg('请上传图片');
						return false;
					}
				}else{
					if(this.areaId.length == 0){
						this.$util.msg('请选择面向地区');
						return false;
					}
					if(this.price.length == 0){
						this.$util.msg('请输入价格');
						return false;
					}
					if(this.reqNail.length == 0){
						this.$util.msg('请输入详细说明');
						return false;
					}
					if(this.travelIndex == '0'){
						if(this.fromWhere.length == 0){
							this.$util.msg('请输入出发地');
							return false;
						}
						if(this.toWhere.length == 0){
							this.$util.msg('请输入目的地');
							return false;
						}
						if(this.limitDate.length == 0){
							this.$util.msg('请选择航班时间');
							return false;
						}
						if(this.fightNumber.length == 0){
							this.$util.msg('请输入航班号');
							return false;
						}
					}
					if(this.travelIndex == '1' || this.travelIndex == '4'){
						if(this.serviceDate.length == 0){
							this.$util.msg('请选择使用日期');
							return false;
						}
						if(this.expiryDate.length == 0){
							this.$util.msg('请选择到期日期');
							return false;
						}
						if(this.hotelName.length == 0){
							this.$util.msg('请输入名称');
							return false;
						}
					}
				}
				
				vm.$util.showMyLoading('加载中');
				var params = {};
				params.reqType = "10";
				params.reqNail = this.$util.textFormat(this.reqNail);
				params.deliveryModel = this.deliveryModel;
				params.storeCorName = this.storeCorName;
				params.storeCorAddr = this.storeCorAddr;
				params.storeCorDesc = this.storeCorDesc;
				params.storeCorlatitude = this.storeCorlatitude;
				params.storeCorlongitude = this.storeCorlongitude;
				params.price = this.price;
				params.fromWhere = this.fromWhere;
				params.toWhere = this.toWhere;
				params.limitDate = this.limitDate;
				params.dqModel = JSON.stringify(this.areaId);
				params.fileList = JSON.stringify(this.finalFileList);
				params.travelTag = this.travelIndex;
				params.isShowConcact = this.isShowConcact ? '1' : '0';
				params.tickTopOrNot = this.tickTopOrNot ? '1' : '0';
				params.serviceDate = this.serviceDate;
				params.expiryDate = this.expiryDate;
				params.hotelName = this.hotelName;
				params.fightNumber = this.fightNumber;
				const initres = await postWithUInfo('/apis/publishReqPost',params);
				if(initres.ec == '0'){
					vm.$util.hideMyLoading();
					this.$util.msg("发布成功",{},()=>{
						vm.$util.goBack();
					});
				}else{
					vm.$util.hideMyLoading();
					this.$util.msg("发布失败，请联系客服",{},()=>{
						
					});
				}
			},
			goChooseClassfiy(){
				this.$router.push({
				  name: 'publishIndex',
				  query: {}
				});
			},
			handleCityChange(e){
				// console.log(e)
			},
			addOrMulitiFileList(params){
				// console.log(params)
				if(params.type == '1'){
					this.finalFileList.push({fileId:params.file.fileId,path:params.file.path,url:params.file.path,thumbPath:params.file.thumbPath})
					// console.log(this.fileList)
				}else if(params.type == '2'){
					this.finalFileList = this.finalFileList.filter((item,index) => {
						return item.fileId != params.file.fileId
					});
					// console.log(this.fileList)
				}
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.radio_warp {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		.radio_itm_warp {
			margin: 0px 10px 10px 0px;
		}
	}
	.container {
		width: 90%;
		margin: 0 auto;
		box-shadow: 0px 4px 16px 1px rgb(0 0 0 / 6%);
		height: 100%;
		padding: 10px 20px;
		.headwarp {
			.head-item {
				width: 30%;
				text-align: left;
				line-height: 50px;
				border-bottom: 2px solid #F1F1F1;
			}
			.active {
				border-bottom: 2px solid #C88854;
			}
		}
		.cont-body {
			margin-top: 20px;
			//overflow: scroll;
			min-height: calc(100% - 100px);
			.content {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				.ctx-item {
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 10px 0;
					width: 600px;
					.bishu {
						color: #FF0000;
						margin-left: 4px;
					}
					.ctx-item-t {
						margin-right: 10px;
						.ctx-item-head {
							line-height: 40px;
							width: 160px;
							text-align: left;
							font-size: 14px;
							font-weight: 700;
						}
						.ctx-item-headdesc {
							font-size: 12px;
							text-align: left;
						}
					}
					.ctx-item-b {
						flex: 1;
						text-align:left;
					}
				}
			}
			.btn-foot {
				margin-top: 10px;
				.btn {
					width: 100px;
					margin: 0 auto;
					background-color: #c88854;
					color: #fff;
					padding: 10px 20px;
					border-radius: 30px;
					cursor: pointer;
				}
			}
		}
	}
</style>
